import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, Fragment } from "react";
import { scImageType, scLinkType, scStringType } from "../../types";
import { Image, RichText } from "@sitecore-jss/sitecore-jss-react"; //Demonstrates usage of an Image content field within JSS.

import { getSessionStorageKey } from "../../util/sessionStorage";
import { rewardsDuck } from "../../ducks/rewards";
import { connect } from "react-redux";
import { AuthenticationState } from "react-aad-msal";
import { LoyaltyAccountStatus } from "../../util/LoyaltyAccountStatus";
import { loyaltyDuck } from '../../ducks/loyalty';
import { useFlags } from 'launchdarkly-react-client-sdk';
var rewardsOperations = rewardsDuck.operations;

var PegModule = function PegModule(props) {
  var _infoButton$value, _infoButton$value2;

  var authenticationState = props.authenticationState,
      fields = props.fields,
      getPegPointsModule = props.getPegPointsModule,
      getPegPointsModuleAuth = props.getPegPointsModuleAuth,
      getOrderPegPoints = props.getOrderPegPoints,
      handleShow = props.handleShow,
      orderId = props.orderId,
      orderSubTotal = props.orderSubTotal,
      earnedPegs = props.earnedPegs,
      isMobilePay = props.isMobilePay,
      store = props.store,
      _props$isThankYouModa = props.isThankYouModal,
      isThankYouModal = _props$isThankYouModa === void 0 ? false : _props$isThankYouModa,
      _props$isCheckout = props.isCheckout,
      isCheckout = _props$isCheckout === void 0 ? false : _props$isCheckout;
  if (!fields || Object.keys(fields).length === 0) return null;
  var backgroundImage = fields.backgroundImage,
      backgroundShape = fields.backgroundShape,
      freeOrderCopy = fields.freeOrderCopy,
      image = fields.image,
      imageFreeOrder = fields.imageFreeOrder,
      infoButton = fields.infoButton,
      loggedInCopy = fields.loggedInCopy,
      notLoggedInCopy = fields.notLoggedInCopy,
      orderDetailCopy = fields.orderDetailCopy,
      pegCounter = fields.pegCounter,
      signInLink = fields.signInLink,
      pausedAccCopy = fields.pausedAccCopy,
      pendingOrderCopy = fields.pendingOrderCopy,
      checkoutCopy = fields.checkoutCopy,
      noPegsEarnedCopy = fields.noPegsEarnedCopy,
      dailyLimitCopy = fields.dailyLimitCopy;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      copy = _useState2[0],
      setCopy = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      copyNew = _useState4[0],
      setCopyNew = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      signInCopy = _useState6[0],
      setSignInCopy = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFreeOrder = _useState8[0],
      setIsFreeOrder = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showPegPie = _useState10[0],
      setShowPegPie = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      userPegs = _useState12[0],
      setUserPegs = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      pegCounterParts = _useState14[0],
      setPegCounterParts = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      mode = _useState16[0],
      setMode = _useState16[1];

  var flags = useFlags();
  var ldTransactionLimitModalAvailable = flags['releaseWebDailyTransactionLimitReachedModal'] ? flags['releaseWebDailyTransactionLimitReachedModal'] : false;
  var ldTransactionLimitModuleAvailable = flags['releaseMaxFiveLoyaltyTransactionLimit'] ? flags['releaseMaxFiveLoyaltyTransactionLimit'] : false;
  var openPegInfoModal = new CustomEvent("openPegInfoModal", {
    detail: {
      show: true
    }
  });
  var openPegPausedModal = new CustomEvent("openPegPausedModal", {
    detail: {
      show: true
    }
  });

  var getPegs = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(total, cartlines) {
      var alcoholicDrinks, newCartLines, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              alcoholicDrinks = ["Beer", "Wine", "Spirits", "Mimosas"];
              newCartLines = cartlines.filter(function (item) {
                var productName = isMobilePay ? item.Description : item.Product.DisplayName;
                return alcoholicDrinks.indexOf(productName) === -1 ? true : false;
              }).map(function (item) {
                return {
                  productId: isMobilePay ? 0 : parseInt(item.Product.ProductChainId),
                  quantity: parseInt(item.Quantity),
                  price: isMobilePay ? parseFloat(item.Amount) : parseFloat(item.LineCost)
                };
              });
              data = {
                type: "purchase",
                value: parseFloat(total),
                productArray: newCartLines
              };

              if (!(authenticationState === AuthenticationState.Authenticated)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", getPegPointsModuleAuth(data).then(function (response) {
                // if response is number then we have the pegs we parsed the response
                if (typeof response === "number") {
                  setUserPegs(response);
                  window.sessionStorage.setItem("tmpMobilePayPegsEarned", response);
                  return response;
                }
              }).catch(function (e) {
                console.error("error", e.message);
              }));

            case 7:
              return _context.abrupt("return", getPegPointsModule(data).then(function (response) {
                // if response is number then we have the pegs we parsed the response
                if (typeof response === "number") {
                  setUserPegs(response);
                  window.sessionStorage.setItem("tmpMobilePayPegsEarned", response);
                  return response;
                }
              }).catch(function (e) {
                console.error("error", e.message);
              }));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getPegs(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var getOrderPegs = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(orderNumber) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", getOrderPegPoints({
                orderNumber: orderNumber
              }).then(function (response) {
                // if response is number then we have the pegs we parsed the response
                if (typeof response === "number") {
                  setUserPegs(response);
                  return response;
                }
              }).catch(function (e) {
                console.error("error", e.message);
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getOrderPegs(_x3) {
      return _ref2.apply(this, arguments);
    };
  }(); // 3 possible states: authenticated, unauthenticated, in progress


  useEffect(function () {
    if (isThankYouModal && window.localStorage.getItem("PegModuleInfo")) {
      var PegModuleInfo = JSON.parse(window.localStorage.getItem("PegModuleInfo"));

      if (PegModuleInfo) {
        setCopy(PegModuleInfo.copy);
        setSignInCopy(PegModuleInfo.signInCopy);
        setIsFreeOrder(PegModuleInfo.isFreeOrder);
        setUserPegs(PegModuleInfo.userPegs);
        setPegCounterParts(PegModuleInfo.pegCounterParts);
        setMode(PegModuleInfo.mode);
        window.localStorage.removeItem("PegModuleInfo");
        return;
      }
    }

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var sessionState, sessionStateOrder, sessionMobilePay, loyaltyStorage, _loyaltyStorage$accou, _loyaltyStorage$trans, authenticationStateToLower, subtotalOrderAmount, pegsEarned, orderPending, order, _ref4, _order$Price, _order$Price2, _order, _ref5, _sessionState$price, _sessionState$price2, _loyaltyStorage$trans2, _loyaltyStorage$accou2, _loyaltyStorage$accou3, _loyaltyStorage$accou4, showTransactionLimitModule;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              sessionState = getSessionStorageKey("cart");
              sessionStateOrder = getSessionStorageKey("cbAccount");
              sessionMobilePay = getSessionStorageKey("mobilepay");
              loyaltyStorage = getSessionStorageKey("loyalty");

              if (!(authenticationState === AuthenticationState.Authenticated && !orderId)) {
                _context3.next = 14;
                break;
              }

              if (!((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused)) {
                _context3.next = 10;
                break;
              }

              setMode("paused");
              return _context3.abrupt("return");

            case 10:
              if (!(ldTransactionLimitModuleAvailable && (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$trans = loyaltyStorage.transactionLimitInfo) === null || _loyaltyStorage$trans === void 0 ? void 0 : _loyaltyStorage$trans.transactionLimitReached) === true)) {
                _context3.next = 14;
                break;
              }

              setMode("transactionLimitReachedMode");
              setCopy(dailyLimitCopy.value);
              return _context3.abrupt("return");

            case 14:
              setPegCounterParts(pegCounter.value.split(" "));

              if (!authenticationState) {
                _context3.next = 50;
                break;
              }

              authenticationStateToLower = authenticationState.toLowerCase();
              subtotalOrderAmount = 0;
              pegsEarned = 0;
              orderPending = false;

              if (!(orderId && earnedPegs !== null)) {
                _context3.next = 26;
                break;
              }

              pegsEarned = earnedPegs;
              setUserPegs(earnedPegs);
              subtotalOrderAmount = orderSubTotal;
              _context3.next = 49;
              break;

            case 26:
              if (!(orderId && sessionStateOrder && sessionStateOrder.orders && sessionStateOrder.orders.length > 0)) {
                _context3.next = 36;
                break;
              }

              // we get the order from the session storage orders array
              order = sessionStateOrder.orders.find(function (order) {
                return order.Id === orderId;
              }); // we get the pegs from the order

              if (!order) {
                _context3.next = 34;
                break;
              }

              subtotalOrderAmount = ((_ref4 = parseFloat((_order$Price = order.Price) === null || _order$Price === void 0 ? void 0 : _order$Price.Subtotal) - parseFloat(((_order$Price2 = order.Price) === null || _order$Price2 === void 0 ? void 0 : _order$Price2.TotalSavings) || 0)) === null || _ref4 === void 0 ? void 0 : _ref4.toFixed(2)) || 0;
              _context3.next = 32;
              return getOrderPegs(order.OrderNumber);

            case 32:
              pegsEarned = _context3.sent;

              if (order.Status === "Pending") {
                orderPending = true;
              }

            case 34:
              _context3.next = 49;
              break;

            case 36:
              if (!(sessionMobilePay && isMobilePay)) {
                _context3.next = 44;
                break;
              }

              _order = sessionMobilePay.check;
              subtotalOrderAmount = _order.NetAmountWithNoTax || 0; // rewards discounts not available for mobile pay orders, so we pass just NetAmountWithNoTax

              _context3.next = 41;
              return getPegs(subtotalOrderAmount, _order.OrderLines);

            case 41:
              pegsEarned = _context3.sent;
              _context3.next = 49;
              break;

            case 44:
              if (!(sessionState && sessionState.cart && sessionState.cart.length > 0)) {
                _context3.next = 49;
                break;
              }

              subtotalOrderAmount = ((_ref5 = parseFloat((_sessionState$price = sessionState.price) === null || _sessionState$price === void 0 ? void 0 : _sessionState$price.Subtotal) - parseFloat(((_sessionState$price2 = sessionState.price) === null || _sessionState$price2 === void 0 ? void 0 : _sessionState$price2.TotalSavings) || 0)) === null || _ref5 === void 0 ? void 0 : _ref5.toFixed(2)) || 0;
              _context3.next = 48;
              return getPegs(subtotalOrderAmount, sessionState.cart);

            case 48:
              pegsEarned = _context3.sent;

            case 49:
              if (authenticationStateToLower === "authenticated") {
                showTransactionLimitModule = ldTransactionLimitModuleAvailable && (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$trans2 = loyaltyStorage.transactionLimitInfo) === null || _loyaltyStorage$trans2 === void 0 ? void 0 : _loyaltyStorage$trans2.transactionLimitReached) ? true : false;

                if (!showTransactionLimitModule && (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Status) !== LoyaltyAccountStatus.Paused) {
                  if (parseFloat(subtotalOrderAmount.toString()) === 0) {
                    setSignInCopy(false);
                    setCopy(freeOrderCopy.value);
                    setIsFreeOrder(true);
                  } else if (parseFloat(loyaltyStorage.account.Balance) === 500 && !orderId) {
                    setCopy(noPegsEarnedCopy.value);
                    setMode('noPegsEarned');
                  } else if (Math.floor(parseFloat(subtotalOrderAmount.toString())) > pegsEarned && parseFloat(loyaltyStorage.account.Balance) + pegsEarned === 500 && !orderId) {
                    setCopy(checkoutCopy.value);
                    setMode('partialPegsEarned');
                  } else if (orderPending) {
                    setCopy(pendingOrderCopy.value);
                    setMode('pendingOrderinPOS');
                  } else {
                    setCopy(orderId && orderId !== '' ? orderDetailCopy.value : loggedInCopy.value);
                    setSignInCopy(false);
                    setIsFreeOrder(false);
                  }
                } else if (showTransactionLimitModule && orderId && (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.Status) !== LoyaltyAccountStatus.Paused) {
                  if (parseFloat(subtotalOrderAmount.toString()) === 0) {
                    setSignInCopy(false);
                    setCopy(freeOrderCopy.value);
                    setIsFreeOrder(true);
                  } else {
                    setCopy(orderId && orderId !== '' ? orderDetailCopy.value : loggedInCopy.value);
                    setSignInCopy(false);
                    setIsFreeOrder(false);
                  }
                } else if (showTransactionLimitModule && orderId && (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.Status) !== LoyaltyAccountStatus.Paused) {
                  if (parseFloat(subtotalOrderAmount.toString()) === 0) {
                    setSignInCopy(false);
                    setCopy(freeOrderCopy.value);
                    setIsFreeOrder(true);
                  } else {
                    setCopy(orderId && orderId !== '' ? orderDetailCopy.value : loggedInCopy.value);
                    setSignInCopy(false);
                    setIsFreeOrder(false);
                  }
                }
              } else if (authenticationStateToLower === "unauthenticated") {
                setCopy(notLoggedInCopy.value);
                setSignInCopy(true);
                setIsFreeOrder(false);
              } else if (authenticationStateToLower === "inprogress") {
                setSignInCopy(false);
                setCopy(freeOrderCopy.value);
                setIsFreeOrder(true);
              } else {
                setIsFreeOrder(false);
                setSignInCopy(false);
                setCopy("");
              }

            case 50:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }, [authenticationState, ldTransactionLimitModuleAvailable]); //PEGPIE SHOW/NO SHOW

  useEffect(function () {
    var sessionStateOrder = getSessionStorageKey("cbAccount");

    if (orderId && sessionStateOrder && sessionStateOrder.orders && sessionStateOrder.orders.length > 0) {
      var order = sessionStateOrder.orders.find(function (order) {
        return order.Id === orderId;
      });

      if ((order === null || order === void 0 ? void 0 : order.Status) === "Pending" && !isFreeOrder) {
        setShowPegPie(false);
      } else {
        setShowPegPie(true);
      }
    } else {
      setShowPegPie(true);
    }
  });
  useEffect(function () {
    setCopyNew(copy);

    if (userPegs >= 0 && copy !== "" && copy.indexOf("#") !== -1) {
      setCopyNew(copy.replace("#", userPegs));
    }
  }, [userPegs, copy]);

  var onInfoClick = function onInfoClick(e) {
    e.preventDefault(); // dispatch the events, for sitecore

    window.dispatchEvent(openPegInfoModal); // for storybook testing only

    if (handleShow) {
      handleShow(true);
    }
  };

  var onPausedClick = function onPausedClick(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    window.dispatchEvent(openPegPausedModal);
  };

  var transactionLimitReachedInfo = function transactionLimitReachedInfo(e) {
    e.preventDefault();

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return props.setTransactionLimitInfo({
                showTransactionLimitModal: true
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  };

  useEffect(function () {
    if (isCheckout) {
      window.localStorage.setItem("PegModuleInfo", JSON.stringify({
        copy: copy,
        signInCopy: signInCopy,
        isFreeOrder: isFreeOrder,
        userPegs: userPegs,
        pegCounterParts: pegCounterParts,
        mode: mode
      }));
    }
  }, [copy, signInCopy, isFreeOrder, userPegs, pegCounterParts, mode]);
  return /*#__PURE__*/React.createElement(Fragment, null, mode === 'paused' ? /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg loyalty__peg--paused"
  }, /*#__PURE__*/React.createElement(Image, {
    field: backgroundImage,
    className: "loyalty__peg-bg-image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-cols"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-info"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "loyalty__peg-info-button",
    title: "Display Modal",
    onClick: onPausedClick
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346628 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.998 5.87889 15.1545 3.84524 13.6546 2.34539C12.1548 0.845545 10.1211 0.00203659 8 0V0ZM7.84616 3.69231C8.02872 3.69231 8.20719 3.74644 8.35899 3.84787C8.51079 3.9493 8.6291 4.09347 8.69897 4.26214C8.76883 4.43081 8.78711 4.61641 8.7515 4.79547C8.71588 4.97453 8.62796 5.139 8.49887 5.2681C8.36977 5.39719 8.2053 5.48511 8.02624 5.52072C7.84718 5.55634 7.66158 5.53806 7.49291 5.4682C7.32424 5.39833 7.18007 5.28002 7.07864 5.12822C6.97722 4.97642 6.92308 4.79795 6.92308 4.61538C6.92308 4.37057 7.02033 4.13578 7.19344 3.96267C7.36655 3.78956 7.60134 3.69231 7.84616 3.69231ZM8.61539 12.3077H8C7.83679 12.3077 7.68027 12.2429 7.56486 12.1274C7.44945 12.012 7.38462 11.8555 7.38462 11.6923V8C7.22141 8 7.06488 7.93516 6.94947 7.81976C6.83407 7.70435 6.76923 7.54782 6.76923 7.38461C6.76923 7.2214 6.83407 7.06488 6.94947 6.94947C7.06488 6.83406 7.22141 6.76923 7.38462 6.76923H8C8.16321 6.76923 8.31974 6.83406 8.43514 6.94947C8.55055 7.06488 8.61539 7.2214 8.61539 7.38461V11.0769C8.7786 11.0769 8.93512 11.1418 9.05053 11.2572C9.16594 11.3726 9.23077 11.5291 9.23077 11.6923C9.23077 11.8555 9.16594 12.012 9.05053 12.1274C8.93512 12.2429 8.7786 12.3077 8.61539 12.3077Z",
    fill: "#653024"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-col-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: image
  })), /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-auth-label"
  }, pausedAccCopy === null || pausedAccCopy === void 0 ? void 0 : pausedAccCopy.value)))) : mode === 'transactionLimitReachedMode' || mode === 'noPegsEarned' ? /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg loyalty__peg--limit-reached"
  }, /*#__PURE__*/React.createElement(Image, {
    field: backgroundImage,
    className: "loyalty__peg-bg-image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-cols"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-info"
  }, /*#__PURE__*/React.createElement("a", {
    href: infoButton === null || infoButton === void 0 ? void 0 : (_infoButton$value = infoButton.value) === null || _infoButton$value === void 0 ? void 0 : _infoButton$value.href,
    className: "loyalty__peg-info-button",
    title: "Display Modal",
    onClick: function onClick(e) {
      if (ldTransactionLimitModalAvailable && mode === 'transactionLimitReachedMode') {
        return transactionLimitReachedInfo(e);
      } else {
        return onInfoClick(e);
      }
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346628 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.998 5.87889 15.1545 3.84524 13.6546 2.34539C12.1548 0.845545 10.1211 0.00203659 8 0V0ZM7.84616 3.69231C8.02872 3.69231 8.20719 3.74644 8.35899 3.84787C8.51079 3.9493 8.6291 4.09347 8.69897 4.26214C8.76883 4.43081 8.78711 4.61641 8.7515 4.79547C8.71588 4.97453 8.62796 5.139 8.49887 5.2681C8.36977 5.39719 8.2053 5.48511 8.02624 5.52072C7.84718 5.55634 7.66158 5.53806 7.49291 5.4682C7.32424 5.39833 7.18007 5.28002 7.07864 5.12822C6.97722 4.97642 6.92308 4.79795 6.92308 4.61538C6.92308 4.37057 7.02033 4.13578 7.19344 3.96267C7.36655 3.78956 7.60134 3.69231 7.84616 3.69231ZM8.61539 12.3077H8C7.83679 12.3077 7.68027 12.2429 7.56486 12.1274C7.44945 12.012 7.38462 11.8555 7.38462 11.6923V8C7.22141 8 7.06488 7.93516 6.94947 7.81976C6.83407 7.70435 6.76923 7.54782 6.76923 7.38461C6.76923 7.2214 6.83407 7.06488 6.94947 6.94947C7.06488 6.83406 7.22141 6.76923 7.38462 6.76923H8C8.16321 6.76923 8.31974 6.83406 8.43514 6.94947C8.55055 7.06488 8.61539 7.2214 8.61539 7.38461V11.0769C8.7786 11.0769 8.93512 11.1418 9.05053 11.2572C9.16594 11.3726 9.23077 11.5291 9.23077 11.6923C9.23077 11.8555 9.16594 12.012 9.05053 12.1274C8.93512 12.2429 8.7786 12.3077 8.61539 12.3077Z",
    fill: "#653024"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-col-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: image
  })), copy && /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-auth-label"
  }, copy)))) : /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg ".concat(mode === 'partialPegsEarned' ? 'loyalty__peg--partial-pegs' : '')
  }, /*#__PURE__*/React.createElement(Image, {
    field: backgroundImage,
    className: "loyalty__peg-bg-image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-cols"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-info"
  }, /*#__PURE__*/React.createElement("a", {
    href: infoButton === null || infoButton === void 0 ? void 0 : (_infoButton$value2 = infoButton.value) === null || _infoButton$value2 === void 0 ? void 0 : _infoButton$value2.href,
    className: "loyalty__peg-info-button",
    title: "Display Modal",
    onClick: onInfoClick
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346628 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.998 5.87889 15.1545 3.84524 13.6546 2.34539C12.1548 0.845545 10.1211 0.00203659 8 0V0ZM7.84616 3.69231C8.02872 3.69231 8.20719 3.74644 8.35899 3.84787C8.51079 3.9493 8.6291 4.09347 8.69897 4.26214C8.76883 4.43081 8.78711 4.61641 8.7515 4.79547C8.71588 4.97453 8.62796 5.139 8.49887 5.2681C8.36977 5.39719 8.2053 5.48511 8.02624 5.52072C7.84718 5.55634 7.66158 5.53806 7.49291 5.4682C7.32424 5.39833 7.18007 5.28002 7.07864 5.12822C6.97722 4.97642 6.92308 4.79795 6.92308 4.61538C6.92308 4.37057 7.02033 4.13578 7.19344 3.96267C7.36655 3.78956 7.60134 3.69231 7.84616 3.69231ZM8.61539 12.3077H8C7.83679 12.3077 7.68027 12.2429 7.56486 12.1274C7.44945 12.012 7.38462 11.8555 7.38462 11.6923V8C7.22141 8 7.06488 7.93516 6.94947 7.81976C6.83407 7.70435 6.76923 7.54782 6.76923 7.38461C6.76923 7.2214 6.83407 7.06488 6.94947 6.94947C7.06488 6.83406 7.22141 6.76923 7.38462 6.76923H8C8.16321 6.76923 8.31974 6.83406 8.43514 6.94947C8.55055 7.06488 8.61539 7.2214 8.61539 7.38461V11.0769C8.7786 11.0769 8.93512 11.1418 9.05053 11.2572C9.16594 11.3726 9.23077 11.5291 9.23077 11.6923C9.23077 11.8555 9.16594 12.012 9.05053 12.1274C8.93512 12.2429 8.7786 12.3077 8.61539 12.3077Z",
    fill: "#653024"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-col-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: image
  })), copyNew && /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-auth-label"
  }, copyNew), signInCopy && /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-auth-label"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: signInLink,
    tag: "p",
    className: "loyalty__peg-auth-sign"
  }))), showPegPie && /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-col-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-counter"
  }, isFreeOrder ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    field: imageFreeOrder
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    field: backgroundShape
  }), /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-desc"
  }, /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-value"
  }, userPegs), /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-label"
  }, pegCounterParts[1]))))))));
};

var loyaltyOperations = loyaltyDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getPegPointsModule: function getPegPointsModule(data) {
      return dispatch(rewardsOperations.handleGetPegPointsModule(data));
    },
    getPegPointsModuleAuth: function getPegPointsModuleAuth(data) {
      return dispatch(rewardsOperations.handleGetPegPointsModuleAuth(data));
    },
    setTransactionLimitInfo: function setTransactionLimitInfo(show) {
      return dispatch(loyaltyOperations.setTransactionLimitInfo(show));
    },
    getOrderPegPoints: function getOrderPegPoints(data) {
      return dispatch(rewardsOperations.handleGetOrderPegPoints(data));
    }
  };
};

export default connect(null, mapDispatchToProps)(PegModule);